export default __webpack_public_path__ + "static/media/close.5c6f3697.svg";